import React from "react";
import Image from "next/image";
import ButtonLink from "@/Components/ButtonLink";
import CardDots from "@/Components/DataDisplayCompoants/CardDots";

const baseUrl = `${process.env.NEXT_PUBLIC_REACT_APP_RESOURCE_BASE_URL}`;

type ServicesIndustryCardProps = {
  backgroundImage: string;
  title: string;
  description: string;
  buttonLabel?: string;
  buttonLink?: string;
};

const ServicesIndustryCard: React.FC< ServicesIndustryCardProps> = ({ backgroundImage,
  title,
  description,
  buttonLabel = "",
  buttonLink = "/",
 }) => {
  return (
    <div className="shadow-[0px_12.68px_57.07px_-7.93px_#001A2D3D] relative group overflow-hidden">
      <Image
        src={`${baseUrl}${backgroundImage}` || ""}
        alt="industry bg"
        width={810}
        height={393}
        quality={100}
        className="w-full xl:aspect-[0.8515] xl:h-auto md:h-[388px] h-[450px] max-h-full object-cover object-center transition-all duration-300 scale-100 ease-in-out group-hover:scale-[1.1] group-focus-within:scale-100"
      />
      <span className="bg-[linear-gradient(180deg,_rgba(0,_0,_0,_0.8)_39.98%,_rgba(0,_0,_0,_0.16)_100%)] absolute top-0 right-0 w-full h-full"></span>
      <CardDots />

      <div className="absolute top-0 left-0 py-[26px] max-w-[680px] px-5">
        <h5 className="text-subtitle-1 font-bold text-primary-text-white">
          {title || ""}
        </h5>
        <p className="text-subtitle-3 font-semibold text-secondary-text-white mt-2">
          {description || ""}
        </p>
        {buttonLabel && buttonLink && (
          <div className="mt-3.5">
            <ButtonLink
              label={buttonLabel}
              className="text-subtitle-4"
              href={buttonLink}
            />
          </div>
        )}
      </div>
    </div>
  );
};
export default ServicesIndustryCard;